import { DatasetId } from "@intelligems/ig-types";

type TestObject = {
  plusMinus: number;
  range: number[];
};
export type TimeSeriesData = {
  [key: string]: number | string | number[] | TestObject;
  xAxisKey: string;
};

export type ProductGroupTableData = {
  [key: string]: number | string;
  productGroup: string;
};

export type ComponentRenderLocation =
  | "sitewide"
  | "personalization"
  | "experiment";

export type ShareSettings = {
  showChange: boolean;
  showImpact: boolean;
  showName: boolean;
};

export enum GraphType {
  Histogram = "histogram",
  StackedBar = "stackedBar",
  StackedBarHorizontal = "stackedBarHorizontal",
  Bar = "bar",
  StackedArea = "stackedArea",
  SyncedBar = "syncedBar",
  ClusteredBar = "clusteredBar",
  BiaxialBar = "biaxialBar",
  Line = "line",
  Sankey = "sankey",
  Table = "table",
}

export type DataType =
  | "numberNoDecimal"
  | "number"
  | "currency"
  | "currencyNoDecimal"
  | "percent"
  | "percentTwoDecimal"
  | "percentNoDecimal"
  | "numberNoRounding"
  | "none";

export type GraphConfig = {
  title: string[];
  metrics: string[];
  canBeKeyMetric?: boolean;
  dataTypes: DataType[];
  datasetId: DatasetId;
  isImpactGraph?: boolean;
  graphType: GraphType;
  stackedBarLegendTitles?: string[];
  showSumStackedLabels?: boolean;
  filterMetric?: string;
  histogramBucket?: string;
  showSumMetric?: boolean;
  hasMetricFilterIndex?: boolean; // has two metrics to switch between
  showLegend?: boolean; // hooked up to line graph currently
  hasProbability?: boolean;
  hasTimeseries?: boolean;
  hasValueCI?: boolean; // confidence interval
  hasAudience?: boolean; // in audience table
  maxGroupAmt?: number;
  hasKDE?: boolean;
  hasCDF?: boolean;
  impactMetric?: string;
  hasImpactCalculation?: boolean;
  isInverted?: boolean; // will change coloring of impact to opposite of normal
};
